// extracted by mini-css-extract-plugin
export default {"frame":"recentes_frame__NsfH9","frameSquare":"recentes_frameSquare__JLMku","imagem":"recentes_imagem__pAEHd","marca":"recentes_marca__knsw1","modelo":"recentes_modelo__tbSUm"};